module.exports = __webpack_public_path__ + "02_short_brown.6c6580c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_short_brown.png
// module id = rEoe
// module chunks = 0